import { Amount } from '~/types';

export const amountToString = (amount: Amount) => {
  return amount.value.toLocaleString('en-US', {
    style: 'currency',
    currency: amount.currency,
    maximumFractionDigits: 3,
  });
};
